import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { loadTextContent, TextContent } from "@/lib/textContent";

const BliSponsor = () => {
  const [text, setText] = useState<TextContent | null>(null);

  useEffect(() => {
    const loadContent = async () => {
      const content = await loadTextContent('bli-sponsor');
      setText(content);
    };
    loadContent();
  }, []);

  return (
    <>
      <section className="pt-24 pb-16 md:pt-32 md:pb-24 px-4 flex-grow">
        <div className="container mx-auto max-w-3xl">
          <Link
            to="/kampanjer/freddy-cyklar"
            className="inline-flex items-center text-minnestig-purple hover:text-minnestig-teal mb-8"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
            </svg>
            Tillbaka
          </Link>

          <div className="bg-white p-8 rounded-3xl shadow-xl">
            <form 
              action="https://minnestig.us21.list-manage.com/subscribe/post?u=c596c46f29e1d14f190b95783&amp;id=e183eccd72&amp;v_id=335&amp;f_id=0008bae6f0" 
              method="post" 
              id="mc-embedded-subscribe-form" 
              name="mc-embedded-subscribe-form" 
              className="validate"
              target="_blank"
            >
              <div id="mc_embed_signup_scroll" className="space-y-6">
                <h2 className="text-4xl md:text-5xl font-bold text-minnestig-teal mb-4">
                  Sponsra Freddy - En Svensk Klassiker
                </h2>
                <p className="text-gray-600 mb-8">
                  Fyll i formuläret så kontaktar vi dig. En intressanmälan är inte bindande. Stort tack för att du engagerar dig.
                </p>

                <div className="space-y-6">
                  <div className="mc-field-group">
                    <label htmlFor="mce-EMAIL" className="block text-sm font-medium text-gray-700 mb-2">
                      E-post <span className="text-red-500">*</span>
                    </label>
                    <Input
                      type="email"
                      name="EMAIL"
                      id="mce-EMAIL"
                      className="required email w-full px-6 py-4 text-base rounded-full border-gray-200"
                      required
                    />
                  </div>

                  <div className="mc-field-group">
                    <label htmlFor="mce-MMERGE2" className="block text-sm font-medium text-gray-700 mb-2">
                      Vad vill ni sponsra med? <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="MMERGE2"
                      id="mce-MMERGE2"
                      className="w-full px-6 py-4 text-base rounded-full border border-gray-200 appearance-none bg-white bg-[url('/icons/chevron-down.svg')] bg-[length:20px_20px] bg-no-repeat bg-[position:calc(100%-24px)_center] pr-12 focus:ring-2 focus:ring-minnestig-purple focus:border-transparent"
                      required
                    >
                      <option value="" disabled selected>Välj ett alternativ</option>
                      <option value="Anmälningsavgift till Vätternrundan (1950 kr)">Anmälningsavgift till Vätternrundan (1950 kr)</option>
                      <option value="Resa och boende Vätternrundan (4500 kr)">Resa och boende Vätternrundan (4500 kr)</option>
                      <option value="Anmälningsavgift till Vansbrosimningen (1395 kr)">Anmälningsavgift till Vansbrosimningen (1395 kr)</option>
                      <option value="Anmälningsavgift till Lidingöloppet (1295 kr)">Anmälningsavgift till Lidingöloppet (1295 kr)</option>
                      <option value="Anmälningsavgift till Vasaloppet (3350 kr)">Anmälningsavgift till Vasaloppet (3350 kr)</option>
                      <option value="Annat">Annat</option>
                    </select>
                  </div>

                  <div className="mc-field-group">
                    <label htmlFor="mce-MMERGE3" className="block text-sm font-medium text-gray-700 mb-2">
                      Vilken organisation representerar du? Ange er hemsida (skriv med https://).
                    </label>
                    <Input
                      type="url"
                      name="MMERGE3"
                      id="mce-MMERGE3"
                      className="url w-full px-6 py-4 text-base rounded-full border-gray-200"
                    />
                  </div>

                  <div className="mc-field-group">
                    <label htmlFor="mce-MMERGE4" className="block text-sm font-medium text-gray-700 mb-2">
                      Något du vill lägga till?
                    </label>
                    <Input
                      type="text"
                      name="MMERGE4"
                      id="mce-MMERGE4"
                      className="text w-full px-6 py-4 text-base rounded-full border-gray-200"
                    />
                  </div>

                  <p className="text-sm text-gray-600">
                    Genom att skicka in dessa uppgifter så accepterar du att information behandlas enligt vår{' '}
                    <Link to="/integritetspolicy" className="text-minnestig-purple hover:underline">
                      integritetspolicy.
                    </Link>
                  </p>

                  <div className="hidden">
                    <input type="hidden" name="tags" value="3035030" />
                    <input type="text" name="b_c596c46f29e1d14f190b95783_e183eccd72" tabIndex={-1} />
                  </div>

                  <Button type="submit" name="subscribe" id="mc-embedded-subscribe" className="w-full bg-[#002B45] hover:bg-minnestig-purple text-white px-8 py-4 rounded-full transition-colors">
                    Skicka
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default BliSponsor;
